import { render, staticRenderFns } from "./SenderMailAddress.vue?vue&type=template&id=1d6f9fe8&scoped=true"
import script from "./SenderMailAddress.vue?vue&type=script&lang=js"
export * from "./SenderMailAddress.vue?vue&type=script&lang=js"
import style0 from "./SenderMailAddress.vue?vue&type=style&index=0&id=1d6f9fe8&prod&scoped=true&lang=scss"
import style1 from "./SenderMailAddress.vue?vue&type=style&index=1&id=1d6f9fe8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d6f9fe8",
  null
  
)

export default component.exports